//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
export default {
  methods: {
    change(e) {
      this.$destroy()
      this.$parent.preload ? this.$parent.addInputFileWithPreload(e.target) : this.$parent.addInputFile(e.target)
      new this.constructor({
        parent: this.$parent,
        el: this.$el,
      })
    }
  }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/upload/input-file.vue